<template>
  <div class="app-container">
    <el-card>
      <div class="box">
        <!-- 功能选择: -->

        <!-- <div class="searchTitle">
          <el-button type="primary" @click="goGenerateAi(1)"
            >AI文生文案</el-button
          ><el-button type="warning" @click="goGenerateAi(2)"
            >AI文生图</el-button
          ><el-button type="success" @click="goGenerateAi(3)"
            >AI图生视频</el-button
          >
        </div> -->
        <div class="formBox">
          <el-form :inline="true" :model="params">
            <el-form-item label="商品ID：">
              <div class="formItemBox">
                <el-button
                  class="formItemBtn"
                  type="primary"
                  @click="goGenerateAi(1)"
                  >AI文生文案</el-button
                >
                <el-input
                  v-model="params.productId"
                  class="input-width"
                  placeholder="请输入商品ID"
                />
              </div>
            </el-form-item>

            <el-form-item label="商品名称：">
              <div class="formItemBox">
                <el-button
                  class="formItemBtn"
                  type="warning"
                  @click="goGenerateAi(2)"
                  >AI文生图</el-button
                >
                <el-input
                  v-model="params.productName"
                  class="input-width"
                  placeholder="请输入商品名称"
                />
              </div>
            </el-form-item>
            <el-form-item label="AI图片类型" prop="canBuy" label-width="100px">
              <div class="formItemBox">
                <el-button
                  class="formItemBtn"
                  type="success"
                  @click="goGenerateAi(3)"
                  >AI图生视频</el-button
                >
                <el-select
                  v-model="params.generateType"
                  placeholder="请选择AI图片类型"
                  style="width: 167px"
                  clearable
                >
                  <el-option
                    v-for="item in $dict.AITypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="Search" @click="queryTableList()"
                >查询</el-button
              >
              <el-button icon="Refresh" @click="resetParams()">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="goods_list" v-if="tableList.length">
        <div class="goods_item" v-for="(item, idx) in tableList" :key="idx">
          <div class="goods_title">
            {{ item.productName }} | {{ item.productId }} |
            {{ getArrVal($dict.AITypeList, item.generateType)["label"] }}
          </div>
          <div class="goods_detail">
            <h4>提示词:</h4>
            <p>{{ item.prompt }}</p>
          </div>
          <!-- 文生文 -->
          <div v-if="item.generateType == 1" class="goods_img_list">
            <div
              class="text_content"
              v-for="(text, index) in item.aiProductResultList"
              :key="index"
            >
              <div v-html="text.aiContent"></div>
              <el-button
                class="selectButton"
                type="primary"
                @click="handleSelect(text)"
                >设为商品详情</el-button
              >
            </div>
          </div>
          <!-- 文生图 -->
          <div v-if="item.generateType == 2" class="goods_img_list">
            <div
              class="goods_img"
              v-for="(img, index) in item.aiProductResultList"
              :key="index"
            >
              <el-image
                :src="img.aiContent"
                class="img"
                fit="scale-down"
              ></el-image>
              <div class="mask"></div>
              <el-button
                class="select"
                type="primary"
                @click="handleSelect(img)"
                >设为商品主图</el-button
              >
              <div class="actionBtn">
                <img
                  src="https://image2.soole.com.cn/slb-picture2025102115062619168.jpg"
                  @click="preview(img)"
                  alt=""
                />
                <img
                  src="https://image2.soole.com.cn/slb-picture2025102115063014599.jpg"
                  @click="downLoad(img)"
                  alt=""
                />
                <!-- <el-button type="text" @click="downLoad(img)">下载</el-button>
                <el-button type="text" @click="preview(img)">预览</el-button> -->
              </div>
            </div>
          </div>
          <!-- 文生视频 -->
          <div v-if="item.generateType == 3" class="goods_img_list">
            <div
              class="goods_img"
              v-for="(img, index) in item.aiProductResultList"
              :key="index"
            >
              <video
                :src="img.aiContent"
                muted
                autoplay
                :controls="true"
                class="img"
              ></video>
              <div v-if="item.generateType != 3" class="mask"></div>
              <el-button
                class="select"
                type="primary"
                @click="handleSelect(img)"
                >设为商品视频</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <el-empty v-else description="暂无历史记录"></el-empty>

      <div class="pagination-container" style="margin-top: 20px">
        <el-pagination
          :current-page="params.pageNo"
          :page-size="params.pageSize"
          :page-sizes="[2, 4, 6, 8]"
          :total="total"
          background
          layout="total, sizes,prev, pager, next,jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-dialog title="图片预览" :visible.sync="dialogVisible" width="400px">
      <img :src="previewImgUrl" alt="" class="previewImg" />
    </el-dialog>
  </div>
</template>
<script>
import { reqHistoryRecord, reqSetGoods } from "@/assets/api/aiProduct";
import ShowVideo from "./product/components/showVideo";
export default {
  components: {
    ShowVideo,
  },
  data() {
    return {
      params: {
        pageNo: 1,
        pageSize: 2,
        productId: "",
        productName: "",
        generateType: "",
      },
      previewImgUrl: "",
      dialogVisible: false,
      listLoading: false,
      tableList: [],
      total: 0,
      waitNum: 0,
    };
  },
  mounted() {
    this.queryTableList();
  },
  methods: {
    async downLoad(img) {
      try {
        const response = await fetch(img.aiContent);
        if (!response.ok) throw new Error("网络请求失败");

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${img.productId}.png`;
        document.body.appendChild(a);
        a.click();

        // 清理
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.$message.success("下载成功");
      } catch (error) {
        console.error("下载失败:", error);
        this.$message.error("下载失败，请重试");
      }
    },
    preview(img) {
      this.previewImgUrl = img.aiContent;
      this.dialogVisible = true;
    },
    // 选中设为图片
    async handleSelect(row) {
      const res = await reqSetGoods({
        aiProductResultId: row.id,
        aiText: row.aiContent,
      });
      if (res.code == 200) {
        this.$message.success(res.message);
      } else {
        this.$message.warning(res.message);
      }
    },
    goGenerateAi(type) {
      this.$router.push({ path: "generateAi", query: { type } });
    },
    /**
     * 查询表格数据
     */
    queryTableList() {
      this.listLoading = true;
      reqHistoryRecord(this.params).then((res) => {
        if (res.code == 200) {
          this.listLoading = false;
          this.tableList = res.data.list || [];
          this.total = Number(res.data.total) || 0;
          this.$message.success(res.message);
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    //重置参数
    resetParams() {
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.params.productId = "";
      this.params.productName = "";
      this.queryTableList();
    },
    handleSizeChange(val) {
      this.params.pageNo = 1;
      this.params.pageSize = val;
      this.queryTableList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.queryTableList();
    },
  },
};
</script>

<style scoped lang="scss">
.searchTitle {
  font-size: 16px;
  font-weight: 600;
  margin: 10px 0 30px 0;
  width: 800px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 300px;
  gap: 40px;
}
.previewImg {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}

.videoCover {
  width: 200px;
  height: 200px;
}

.emptyText {
  color: #acb2c3;
  font-size: 14px;
}
.type {
  margin: 30px 0;
}
.goods_title {
  font-size: 18px;
  font-weight: 500;
}
.goods_detail {
  h4 {
    width: 60px;
  }
  margin: 50px 0;
  display: flex;
}
.goods_list {
  width: 90%;
  .goods_item {
    padding: 20px;
    background-color: #f2f2f2;
    border-radius: 10px;
    margin-bottom: 20px;

    .goods_img_list {
      display: flex;
      .goods_img {
        position: relative;
        display: flex;
        overflow: hidden;
        width: 375px;
        height: 375px;
        transition: transform 0.5s;
        margin-right: 20px;

        .img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
          cursor: pointer;
        }
        .select {
          position: absolute;
          display: none;
          z-index: 9;
          top: 300px;
          left: 130px;
        }
        .actionBtn {
          position: absolute;
          display: none;
          z-index: 9;
          bottom: 16px;
          right: 0px;
          img {
            width: 20px;
            height: 20px;
            cursor: pointer;
            margin-right: 16px;
          }
        }
        .mask {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.2);
          // &:nth-child(2) {
          //   height: 25%;
          //   top: 35%;
          // }
        }
      }
      .goods_img:hover .mask,
      .goods_img:hover .select,
      .goods_img:hover .actionBtn {
        display: flex;
      }
    }
  }
}
.box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 40px;
}
.formItemBox {
  position: relative;
}
.formItemBtn {
  position: absolute;
  right: 0;
  top: -130%;
}
.formBox {
  width: 100%;
}
.selectButton {
  margin-top: 16px;
}
</style>
